import { render, staticRenderFns } from "./cardInfo.vue?vue&type=template&id=ffe3361c&scoped=true&"
import script from "./cardInfo.vue?vue&type=script&lang=js&"
export * from "./cardInfo.vue?vue&type=script&lang=js&"
import style0 from "./cardInfo.vue?vue&type=style&index=0&id=ffe3361c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe3361c",
  null
  
)

component.options.__file = "cardInfo.vue"
export default component.exports